import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import axios from 'axios';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetTicketsListComponent';

var styles = AppSettings.styles;

class TicketsList extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            errorTicketsList: false,
            errorMessage: "",
            ticketsList: [],
            showLoadingTicketList: true,
            opened:false
        }

        //context.setViewGroup(false);
        this.getTicketsList = this.getTicketsList.bind(this);
    }

    getTicketsList(event) {
        if(this.state.opened){
            this.setState({
                errorTicketsList: false,
                errorMessage: "",
                ticketsList: [],
                showLoadingTicketList: true,
                opened: false
            });
            return;
        }        

        this.setState({
            showLoadingTicketList: true,
            opened:true
        });

        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        let startDate = dd + "-" + mm + "-" + yyyy;


        let endDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));

        dd = endDate.getDate();
        mm = endDate.getMonth() + 1;
        yyyy = endDate.getFullYear();
        endDate = dd + "-" + mm + "-" + yyyy;

        var url = AppSettings['env'].urlUserBoxTicketsList.replace('[START_DATE]', startDate).replace('[END_DATE]', endDate);
        var dataPost = {
            "Username":"",
            "SessionToken":"",
            "WithTerrestrial": true,
            "WithDetail": false
            };
        axios.post(url, dataPost)
            .then(({data, status, statusText}) => {
                var showLoadingTicketList = false;
                if (data.errors.length == 0) {
                    this.setState({
                        errorTicketsList: false,
                        errorMessage: "",
                        ticketsList: data.receipts,
                        showLoadingTicketList: showLoadingTicketList,
                        
                    });
                } else {
                    this.setState({
                        errorTicketsList: true,
                        errorMessage: "La tua sessione è scaduta",
                        ticketsList: [],
                        showLoadingTicketList: showLoadingTicketList,
                        opened: true
                    });
                }
            })

            .catch(function(error) {
                this.setState({
                    errorTicketsList: true,
                    errorMessage: "",
                    ticketsList: [],
                    showLoadingTicketList: false,
                    opened: true
                });
            });
    }



    renderTicketList(){
        var ticketsList;

        if (this.state.ticketsList.length > 0) {
            ticketsList = this.state.ticketsList.map(function (ticket, i) {
                var key = ticket.ticketId;
                var risk = ticket.risk;
                var paid = ticket.paidAmount;
                switch (ticket.status) {
                    case 'opened':
                        var paid = "-";
                        break;
                    case 'losing':
                        var paid = "-";
                        break;
                    case 'winning':
                        var paid = risk;
                        break;

                }
                var canale = "online";
                var titleCanale = "Online";
                if(ticket.isTerrestrial){
                    canale = "agenzia"
                    titleCanale = "Online";
                }
                var className = "mg-bet-" + ticket.status;

                var ticketDetail = () => {
                    window.open(ticket.link, "_blank");
                }

                return (
                    <tr key={key} className={className} onClick={ticketDetail} title="Visualizza dettagli della scommessa">
                        <td className="mg-icona-status"></td>
                        <td>{ticket.date}<br />{ticket.amount} </td>
                        <td>{risk}</td>
                        <td title={titleCanale}>{canale}</td>
                    </tr>
                )
            });
        }
        else {
            ticketsList = <tr>
                <td colSpan="4" className="userBoxBetTicket--noresult">Non sono presenti scommesse sportive</td>
            </tr>;
        }

        return (
            <table className="userBoxTable userBoxBetTicket">
                <thead>
                    <tr className="userBoxBetTicket--head">
                        <th></th>
                        <th>Giocata</th>
                        <th>Potenziale</th>
                        <th>Canale</th>
                    </tr>
                </thead>
                <tbody>
                {ticketsList}
                </tbody>
            </table>
        );
    }

    render() {

        var title = <div style={styles.pointer} onClick={this.getTicketsList}>Le tue giocate</div>;
        var subTitle  = <div style={styles.pointer} onClick={this.getTicketsList}>Ultime 10 scommesse</div>;

        var openTutteLeGiocate = (e) => {
            this.context.openLinkPopup(e, AppSettings.homeRealm + 'betMg/betReport');
        }

        return (
            <div className="mg-user-widget">
                <Card expanded={this.state.opened} onExpandChange={this.getTicketsList} containerStyle={styles.mgCardStyle}>
                    <CardHeader titleStyle={styles.mgCardTitle}
                                subtitleStyle={styles.mgCardSubTitle}
                                title={title}
                                subtitle={subTitle}
                                actAsExpander={false}
                                showExpandableButton={true}
                    />
                    <CardText expandable={true}>
                        {this.state.showLoadingTicketList?
                        <CircularProgress style={styles.loadingIcon}/>
                            : this.renderTicketList()
                        }
                        <MGSiteButton
                            href={AppSettings.homeRealm+'betMg/betReport'}
                            title="Tutte le giocate"
                            class=""
                            label="Tutte le giocate"
                            disabled={false}
                            primary={true}
                            isButton={true}
                            fullWidth={true}
                            actionFunc={openTutteLeGiocate}
                        />
                    </CardText>
                </Card>
            </div>

        );
    }
}

TicketsList.displayName = componentName;

// PropTypes validation
TicketsList.propTypes = {};

// default props
TicketsList.defaultProps = {};

TicketsList.contextTypes = {
    setViewGroup: PropTypes.func,
    openLinkPopup: PropTypes.func
}

export default TicketsList;